import { jsx as t } from "react/jsx-runtime";
import { createContext as u, forwardRef as b } from "react";
import { useCheckboxGroup as k } from "@chakra-ui/checkbox";
import { FormControl as v } from "../FormControl/FormControl.mjs";
const G = u(null), N = b((a, P) => {
  const {
    children: l,
    name: o,
    formHelperText: n,
    hideOptionalLabel: c = !1,
    id: e = o,
    label: s,
    onChange: i,
    value: m,
    error: p,
    variant: d = "checkbox",
    controlStyleProps: x,
    controlClassName: h,
    "data-testid": r,
    ...C
  } = a, { getCheckboxProps: f } = k({
    onChange: i,
    value: m
  });
  return /* @__PURE__ */ t(
    v,
    {
      formHelperText: n,
      error: p,
      label: s,
      name: o,
      id: e,
      "data-testid": r && `${r}-control`,
      className: h,
      hideOptionalLabel: c,
      ...x,
      ...C,
      children: /* @__PURE__ */ t(G.Provider, { value: { getCheckboxProps: f, variant: d, id: e }, children: l })
    }
  );
});
N.displayName = "CheckboxGroup";
export {
  N as CheckboxGroup,
  G as CheckboxGroupContext
};
